import React from 'react';
import classNames from 'classnames';
import isFunction from 'lodash/isFunction';

import { Details, Popover, useDetails } from '@primer/react';

import Button from '../Button/Button';
import CaretDownIcon from '../icons/CaretDownIcon';
import CaretUpIcon from '../icons/CaretUpIcon';
import Label from '../Labels/Label';

export const ModalDropdown = ({
  renderModal,
  menuWidth = '576px',
  labelSize= 'md',
  dropdownLabel = 'Select',
  isDisabled = false,
  hideCaret = false,
  direction = 'top-left',
}) => {
  const { getDetailsProps, open, setOpen } = useDetails({ closeOnOutsideClick: true });

  if (isDisabled) {
    return <Button disabled><span className="text-lg">{ dropdownLabel }</span></Button>
  }

  return (
    <Details
      className={
        classNames(
          'brand-select w-min text-brand appearance-none cursor-pointer relative',
          { 'bg-border-dark': open },
          { 'bg-white': !open },
        )
      }
      {...getDetailsProps()}
    >
      <Button as="summary">
        <div className="flex justify-between items-center">
          <Label size={labelSize}>{ dropdownLabel }</Label>
          {
            hideCaret ? null : (
              <div className="ml-2">
                { open ? <CaretUpIcon fill="brand" /> : <CaretDownIcon fill="brand" /> }
              </div>
            )
          }
        </div>
      </Button>
      <Popover
        sx={{ mt: 1 }}
        caret={direction}
        open={open}
      >
        <Popover.Content
          sx={{ width: menuWidth, p: 1 }}
        >
          {
            isFunction(renderModal) ? renderModal({ setOpen }) : null
          }
        </Popover.Content>
      </Popover>
    </Details>
  )
}

export default ModalDropdown;
